import * as React from "react";
import { useState } from "react";
import styled, { css } from "styled-components";
import { Trans, useTranslation } from "react-i18next";
import { Icon } from "components/common";
export const InfoButtonStyled = styled.span`
  padding: 0;
  margin: 0;
  opacity: 0.3;
  transition: opacity 0.3s;

  &:hover {
    opacity: 1;
  }
`;
export const RuleDescription = styled.div(
  ({ $mousePos, theme }) => css`
    position: fixed;
    top: ${($mousePos == null ? void 0 : $mousePos.y) || 0}px;
    left: ${($mousePos == null ? void 0 : $mousePos.x) || 0}px;
    margin-top: 23px;
    margin-left: 8px;
    padding: 8px;
    max-width: 600px;

    opacity: 0;

    white-space: pre-line;

    border: 1px solid ${theme.colors.input.border};
    border-radius: 4px;
    background-color: ${theme.colors.global.background};
    box-shadow: 0 5px 10px -2px rgba(0, 0, 0, 0.5);

    overflow: hidden;

    z-index: 20;

    &.show {
      animation: 0.3s linear show;
      animation-delay: 0.8s;
      animation-fill-mode: forwards;
    }

    @keyframes show {
      from {
        opacity: 0;
      }

      to {
        opacity: 1;
      }
    }
  `
);
const SPACE_FROM_POINTER = 8;
function RuleInfoTooltip({ rule }) {
  const { t } = useTranslation("enterprise_security_sigma");
  const [mousePos, setMousePos] = useState({ x: 0, y: 0 });
  const [showTooltip, setShowTooltip] = useState(false);
  const onMouseEnter = (event) => {
    const { x, y } = event.target.getBoundingClientRect();
    setMousePos({ x: x + SPACE_FROM_POINTER, y: y + SPACE_FROM_POINTER });
    setShowTooltip(true);
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    InfoButtonStyled,
    {
      "data-testid": "info-button",
      onMouseEnter,
      onMouseLeave: () => setShowTooltip(false)
    },
    /* @__PURE__ */ React.createElement(Icon, { "data-testid": "more-info", style: { cursor: "pointer" }, name: "help", size: "sm" })
  ), showTooltip && /* @__PURE__ */ React.createElement(RuleDescription, { $mousePos: mousePos, className: showTooltip ? "show" : "", "data-testid": "rule-description" }, /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement(Trans, { t, i18nKey: "rule_tooltip.file_name", values: { name: rule.name }, components: { bold: /* @__PURE__ */ React.createElement("b", null) } })), /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "rule_tooltip.description",
      values: { description: rule.rule_description },
      components: { bold: /* @__PURE__ */ React.createElement("b", null) }
    }
  )), !!rule.product && /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "rule_tooltip.product",
      values: { product: rule.product },
      components: { bold: /* @__PURE__ */ React.createElement("b", null) }
    }
  )), !!rule.tags && /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "rule_tooltip.tags",
      values: { tags: rule.tags.split(" ").join(", ") },
      components: { bold: /* @__PURE__ */ React.createElement("b", null) }
    }
  ))));
}
export default RuleInfoTooltip;
